import classNames from 'classnames';
import './Chip.scss';

interface Props {
    text: string;
    variant?: 'default' | 'outline';
    color?: 'primary' | 'warning' | 'success' | 'danger';
    className?: string;
}

export function Chip({ className, text, variant = 'default', color = 'primary' }: Props) {
    return (
        <div
            className={classNames('Chip', className, `Chip--${color}`, `Chip--${variant}`)}
            data-testid="Chip"
        >
            {text}
        </div>
    );
}
